"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("./api");
const billing_1 = require("./billing");
const lambda_1 = require("./lambda");
class DtsApiClient {
    constructor(config, options) {
        this.config = config;
        this.options = options;
        this.clients = [];
        this.clients.push(this.api = new api_1.ApiClient(this.config, this.options));
        this.clients.push(this.billing = new billing_1.BillingClient(this.config, this.options));
        this.clients.push(this.lambda = new lambda_1.LambdaClient(this.config, this.options));
    }
}
exports.DtsApiClient = DtsApiClient;
